(function () {
    'use strict';
  
    angular
      .module('app.common')
      .directive('nextAvailableTour', function () {
        return {
          restrict: 'E',
          scope: {
            tourTimes: '=',
            allowToday: '=',
            tourDayOfWeek: '=?',
          },
          template: `
              <span class="tour-time" ng-show="tourTimesLoading"><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></span>
              <span class="tour-time full" ng-show="!tourTimesLoading"><% nextTourFull %></span>
              <span class="tour-time short" ng-show="!tourTimesLoading"><% nextTourShort %></span>
          `,
          controller: ['$scope', 'TourService', function ($scope, TourService) {
            $scope.tourTimesLoading = true;
            const nextTourDate = TourService.calculateNextAvailableTour($scope.tourTimes, $scope.allowToday);

            $scope.$watch('allowToday', function (newValue) {
                const nextTour = TourService.calculateNextAvailableTour($scope.tourTimes, $scope.allowToday);
                $scope.nextTour = formatTourDate(nextTour);
            });
        
            $scope.$watch('tourTimes', function (newValue) {
                const nextTour = TourService.calculateNextAvailableTour($scope.tourTimes, $scope.allowToday);
                
                $scope.nextTour = formatTourDate(nextTour);
            });

            function formatTourDate(date) {
              if (!date) return null;
              $scope.tourTimesLoading = false;
  
              const now = new Date();
              const isToday = date.toDateString() === now.toDateString();
              const isTomorrow = date.toDateString() === new Date(now.getTime() + 86400000).toDateString();
  
              const timeFormatter = new Intl.DateTimeFormat('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true,
              });

              const longDateFormatter = new Intl.DateTimeFormat('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              });

              const shortDateFormatter = new Intl.DateTimeFormat('en-US', {
                month: 'short',
                day: 'numeric',
              });

              let full = '', short = '';

              if (isToday) { 
                $scope.tourDayOfWeek = 'today';
                full = `Today at ${timeFormatter.format(date)}`;
                short = `Today @ ${timeFormatter.format(date)}`;
              } else if (isTomorrow) { 
                $scope.tourDayOfWeek = 'tomorrow';
                full = `Tomorrow at ${timeFormatter.format(date)}`;
                short = `Tomorrow @ ${timeFormatter.format(date)}`;
              } else {
                $scope.tourDayOfWeek = longDateFormatter.format(date);
                full = `${longDateFormatter.format(date)} at ${timeFormatter.format(date)}`;
                short = `${shortDateFormatter.format(date)} @ ${timeFormatter.format(date)}`;
              }

              $scope.nextTourFull = full;
              $scope.nextTourShort = short;

              return full;
  
            }
  
            $scope.nextTour = formatTourDate(nextTourDate);
          }]
        };
      });
  })();
  